module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxOCAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0wIDEyLjAzNTZINlYxMC4wMzU2SDBWMTIuMDM1NlpNMCAwLjAzNTY0NDVWMi4wMzU2NEgxOFYwLjAzNTY0NDVIMFpNMCA3LjAzNTY0SDEyVjUuMDM1NjRIMFY3LjAzNTY0WiIgZmlsbD0iIzQ0NDU0NSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/editor-align-left.svg
// module id = TChx
// module chunks = 1